import { ALLOWED_LANGUAGES } from 'constants/general.constants'
import { setSearchParams } from 'utils/queryString.utils'
import { marketingWebHosts } from 'libs/configs'

import elopageLogoBlack from '../../assets/svg/elopage-dark.svg'

import './app-header.scss'

const AppHeader = () => {
  const changeLocale = (locale) => setSearchParams({ locale })

  const Lang = (
    <div className='app-header__language-selector'>
      {Object.values(ALLOWED_LANGUAGES).map((lang) => (
        <button
          key={lang.value}
          type='button'
          className={I18n.locale === lang.value ? 'app-header__language-selector--active' : ''}
          onClick={() => changeLocale(lang.value)}
        >
          {lang.value}
        </button>
      ))}
    </div>
  )
  return (
    <div className='app-header'>
      <div className='app-header__container'>
        <a href={`https://${marketingWebHosts.production}/`}>
          <img className='app-header__logo' src={elopageLogoBlack} alt='logo' />
        </a>
        {Lang}
      </div>
    </div>
  )
}

export default AppHeader
